import { render, staticRenderFns } from "./PartnerLogin.vue?vue&type=template&id=5ee1db41&scoped=true"
import script from "./PartnerLogin.vue?vue&type=script&lang=ts"
export * from "./PartnerLogin.vue?vue&type=script&lang=ts"
import style0 from "./PartnerLogin.vue?vue&type=style&index=0&id=5ee1db41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee1db41",
  null
  
)

export default component.exports